






import { Component, Vue } from 'vue-property-decorator'

@Component({
    components: {
        vueDropzone: () => import('vue2-dropzone')
    }
})
export default class VDropzone extends Vue {

    options: object = {
        url: process.env.VUE_APP_DOT_NET_API_BASE_URL,
        // acceptedFiles: process.env.VUE_APP_VUE_DROPZONE_ACCEPTED_FILES,
        maxFilesize: 100000,
        addRemoveLinks: false,
        autoProcessQueue: false,
        thumbnailWidth: 180,
        thumbnailHeight: 180
    }

    getQueuedFiles() {
        const vdropzone: any = this.$refs.vdropzone as Vue
        return vdropzone.getQueuedFiles()
    }

    removeFile(file: any) {
        const vdropzone: any = this.$refs.vdropzone as Vue
        return vdropzone.removeFile(file)
    }

    enqueueFile(file: any) {
        const vdropzone: any = this.$refs.vdropzone as Vue
        let dropzoneChecker = setInterval(() => {
            if (vdropzone !== undefined) {
                clearInterval(dropzoneChecker);
                
                // Add the file first
                vdropzone.manuallyAddFile(file, file.name, file.size, null, {
                    dontSubstractMaxFiles: false,
                    addToFiles: true
                });
                
                // If file has a preview URL, manually set it
                if (file.dataURL) {
                    setTimeout(() => {
                        // Find the preview element for this specific file by matching filename
                        const previewElements = vdropzone.$el.querySelectorAll('.dz-preview');
                        
                        for (let i = 0; i < previewElements.length; i++) {
                            const preview = previewElements[i];
                            const filenameElement = preview.querySelector('.dz-filename [data-dz-name]');
                            
                            if (filenameElement && filenameElement.textContent === file.name) {
                                const thumbnailImg = preview.querySelector('[data-dz-thumbnail]');
                                if (thumbnailImg) {
                                    thumbnailImg.src = file.dataURL;
                                    break; // Found and updated the correct preview
                                }
                            }
                        }
                    }, 200); // Increased delay to ensure DOM is fully updated
                }
            }
        }, 1000);
    }


}
